import { useEffect, useState } from 'react';

import { Button, Dialog, Field, Textarea } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import type { ApiError } from '../../../lib/errors';

export interface HopYKienProps {
  open: boolean;
  /** Trả lại thì ý kiến **bắt buộc** (đặc tả mục 10.3) — người thẩm định cần biết sửa gì. */
  traLai: boolean;
  dangChay: boolean;
  loi: ApiError | null;
  onClose: () => void;
  onGui: (yKien: string) => void;
}

export function HopYKien({ open, traLai, dangChay, loi, onClose, onGui }: HopYKienProps) {
  const { t } = useT();
  const dichLoi = useLoi();
  const [yKien, setYKien] = useState('');

  useEffect(() => {
    if (open) setYKien('');
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t(traLai ? 'thamDinh.raSoat.traLaiTieuDe' : 'thamDinh.raSoat.pheDuyetTieuDe')}
    >
      <div className="space-y-4 pt-2">
        <p className="text-sm text-content-secondary">
          {t(traLai ? 'thamDinh.raSoat.traLaiThan' : 'thamDinh.raSoat.pheDuyetThan')}
        </p>

        {loi && (
          <p className="rounded border border-danger-200 bg-danger-50 p-3 text-sm text-danger-700">
            {dichLoi(loi)}
          </p>
        )}

        <Field
          label={t('thamDinh.raSoat.yKien')}
          required={traLai}
          hint={traLai ? t('thamDinh.raSoat.yKienBatBuoc') : t('thamDinh.raSoat.yKienTuyChon')}
        >
          {(p) => <Textarea {...p} rows={3} value={yKien} onChange={(e) => setYKien(e.target.value)} />}
        </Field>

        <div className="flex justify-end gap-2">
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.huy')}
          </Button>
          <Button
            variant={traLai ? 'destructive' : 'primary'}
            size="md"
            loading={dangChay}
            disabled={traLai && !yKien.trim()}
            onClick={() => onGui(yKien.trim())}
          >
            {t(traLai ? 'thamDinh.raSoat.traLai' : 'thamDinh.raSoat.pheDuyet')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
